import * as Action from "@actions/index";

const InitialState = {
  status: "loading",
  list: [],
  error: "",
};

export default function CompanyCity(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Company.City.SET_LIST:
      return { ...state, list: action.data };
    case Action.Company.City.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Company.City.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Company.City.CLEAR:
      return { ...state, list: [] };
    default:
      return state;
  }
}
